import ReactDOM from 'react-dom';
import App from './App';
import { GoogleOAuthProvider,GoogleLogin  } from '@react-oauth/google';
ReactDOM.render(


<GoogleOAuthProvider clientId="140747619313-f1cvn8ntfdllc35hst2tc75653d8jeb9.apps.googleusercontent.com">
    
<App/>
</GoogleOAuthProvider>
, document.getElementById('root'));